import { createApp        } from 'vue'
import  checkPermision      from '@/core/directiveCoreCheckPermission'; 
import  tooltipDirective    from '@/core/directiveCoreToolTip'; 
import { createPinia      } from 'pinia'
import { AxiosInterceptor } from '@/core/interceptorCoreAxios'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

const options = {
    position: "bottom-right",
    timeout: 7000,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: "button",
    icon: true
};

  
import App    from './App.vue'
import router from './router'
import Maska  from 'maska'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'


import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

import '../node_modules/admin-lte/plugins/fontawesome-free/css/all.min.css'
import '../node_modules/admin-lte/plugins/overlayScrollbars/css/OverlayScrollbars.min.css'
import '../node_modules/admin-lte/dist/css/adminlte.min.css'
import '@/assets/modal.css'

import '../node_modules/admin-lte/plugins/jquery/jquery.min.js'
import '../node_modules/admin-lte/plugins/bootstrap/js/bootstrap.bundle.min.js'
import '../node_modules/admin-lte/plugins/overlayScrollbars/js/jquery.overlayScrollbars.min.js'
import '../node_modules/admin-lte/dist/js/adminlte.js'

/*pagination */
import paginationButtons from '@/core/baseComponent/paginator/paginatorButtons.vue';


import itemsButtons from '@/core/baseComponent/paginator/itemsButtons.vue';
import loadingPaginator from '@/core/baseComponent/paginator/loadingPaginator.vue';
import sortColum from '@/core/baseComponent/paginator/sortColum.vue';
import dropdownHeader from '@/core/baseComponent/dropmenu/dropdownHeader.vue';

/*cards*/
import cardBase from '@/core/baseComponent/cards/cardBase.vue';
import cardHead from '@/core/baseComponent/cards/cardHeadCustom.vue';
/*modal*/
import modalBase from '@/core/baseComponent/modal/modalTeleport.vue';
import btnTemplate from '@/core/baseComponent/buttons/btnTemplate.vue';
import btnToggle from '@/core/baseComponent/buttons/btnToggle.vue';
import modalHead from '@/core/baseComponent/modal/modalHead.vue'; 
/*forms */
import areaInput   from './core/baseComponent/forms/areaInput.vue';
import textInput   from '@/core/baseComponent/forms/textInput.vue';
import selectInput from '@/core/baseComponent/forms/selectInput.vue';
import ipInput     from '@/core/baseComponent/forms/ipInput.vue';
import numberInput from '@/core/baseComponent/forms/numberInput.vue';
import dateTimeInput from '@/core/baseComponent/forms/dateTime/dateTimeInput.vue';
import dateTimeEndInput from '@/core/baseComponent/forms/dateTime/dateTimeEndInput.vue';
import dateInputMin from '@/core/baseComponent/forms/dateTime/dateInputMin.vue';
import dateInputMax from '@/core/baseComponent/forms/dateTime/dateInputMax.vue';
import dateInput from '@/core/baseComponent/forms/dateTime/dateInput.vue';
/*table */
import tbodyEmpaty from '@/core/baseComponent/table/tbodyEmpaty.vue';
/*list */
import liDetail from '@/core/baseComponent/list/liDetail.vue';
import liDetailCompled from '@/core/baseComponent/list/liDetailCompled.vue';
/*loading */
import loadingCircle from '@/core/baseComponent/loading/loadingCircle.vue';

import boxTemplate from '@/core/baseComponent/box/boxTemplate.vue';
import metricBox from '@/core/baseComponent/box/metricBox.vue';

AxiosInterceptor();


const myApp = createApp(App);
myApp.component('paginationButtons', paginationButtons);
myApp.component('itemsButtons', itemsButtons);
myApp.component('loadingPaginator', loadingPaginator);
myApp.component('sortColum', sortColum);
myApp.component('dropdownHeader', dropdownHeader);


myApp.component('areaInput', areaInput);
myApp.component('textInput', textInput);
myApp.component('selectInput', selectInput);
myApp.component('ipInput', ipInput);
myApp.component('numberInput', numberInput);
myApp.component('dateTimeInput', dateTimeInput);
myApp.component('dateTimeEndInput', dateTimeEndInput);
myApp.component('dateInputMin', dateInputMin);
myApp.component('dateInputMax', dateInputMax);
myApp.component('dateInput', dateInput);


myApp.component('cardBase', cardBase);
myApp.component('cardHead', cardHead);
myApp.component('modalBase', modalBase);
myApp.component('modalHead', modalHead);
myApp.component('btnTemplate', btnTemplate);
myApp.component('btnToggle', btnToggle);
myApp.component('tbodyEmpaty', tbodyEmpaty);
myApp.component('liDetail', liDetail);
myApp.component('liDetailCompled', liDetailCompled);


myApp.component('loadingCircle', loadingCircle);

myApp.component('boxTemplate', boxTemplate);
myApp.component('metricBox', metricBox);


myApp.directive('checkPermision', checkPermision);
myApp.directive('tooltip', tooltipDirective);


const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
myApp.use(Toast, options);
myApp.use(router);
myApp.use(pinia);
myApp.use(VueSweetalert2);
myApp.use(Maska);
myApp.mount('#app');
